import * as moment from "moment-timezone";
import DatePicker from "react-datepicker";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FlagIcon from "react-flag-kit/lib/FlagIcon";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormControl from "@material-ui/core/FormControl";

import InputDatepicker from "./InputDatepicker";
import { SCButtonAddInput } from "../../Buttons/styles";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import { getLevels } from "../../../store/middleware/generic.middleware";
import IconAvatar from "../../../assets/images/profile/img_placeholder.svg";
import { getLocalTimeFromUtc, userTimezoneConvert } from "../../../utils/utils";
import { getAffiliateAll, getClassTimes, getLangAll, getTeachers } from "../../../store/middleware";

function InputForLingoArray(props) {
  const {
    name,
    data,
    timezone,
    addField,
    removeField,
    showAddLingo,
    nativeLanguageId,
    childInputChange,
    newItem = {
      disabledEdit: null,
      lingoLanguageId: "",
      status: "pending",
      scheduledDate: moment().format("YYYY-MM-DD"),
      scheduledStart: "",
      scheduledEnd: "",
      teacherId: "",
      levelByStudent: "1",
      levelByLingo: "",
      affiliateSlug: "",
    },
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { teacherManagement } = useSelector((state) => state.companyManagerReducer);
  const { allLingos, demoClass, levels } = useSelector((state) => state.genericReducer);

  const [lingoClassTimes, setLingoClassTimes] = useState(null);
  const [scheduledDate, setScheduledDate] = useState(moment());

  const urlUS = `https://lingofor.me/lingo-en/try/plans/index.html?user=`;
  const urlES = `https://lingofor.me/lingo-es/conozca/planes/index.html?user=`;
  const urlBR = `https://lingofor.me/lingo-pt/conheca/planos/index.html?user=`;

  const loadInfos = () => {
    dispatch(getLangAll());
    dispatch(getLevels());
    dispatch(getClassTimes()).then((res) => setLingoClassTimes(res));
    dispatch(
      getTeachers({
        status: "1",
        countryId: "",
        demoClass: props.name === "demoClassSchedules" ? "1" : "fsdf",
        firstClass: "",
        levelId: "",
        name: "",
        nativeLanguageId: "",
        isTraining: "",
        otherLanguageId: "",
        ratingFrom: "",
        ratingTo: "",
        skip: "",
        take: "",
      }),
    );
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const statusOptions = ["review", "pending", "noShow", "done", "canceled", "cancelledOutOfLimit", "confirmed"].map(
    (option) => {
      return { id: option, name: option };
    },
  );

  const levelOptions = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((option, index) => {
    return { id: index, name: option };
  });

  const teachersAndCoordinators = teacherManagement?.map(
    ({ teacherId, teacherName, nativeLanguageName, otherLanguageName, languagesOfTeacher }) => {
      return { id: teacherId, name: teacherName, nativeLanguageName, otherLanguageName, languagesOfTeacher };
    },
  );

  const lingoLevelsOptions = levels?.map(({ id, level }) => {
    return { id, name: level };
  });

  const atualDate = getLocalTimeFromUtc(user);

  const userTimezoneConvert2 = (time, userTimezone) => {
    let timezoneUser = moment.tz(moment(time).format("YYYY-MM-DD HH:mm"), userTimezone);
    return timezoneUser.clone().tz(user?.timezone);
  };

  const setDate = (birth_date, index) => {
    setScheduledDate(birth_date.value);
    childInputChange({ id: birth_date.id, value: moment(birth_date.value).format("YYYY-MM-DD") }, index);
  };

  const handleAffiliateSlug = (e, index) => {
    const { value } = e.target;

    if (value.length > 0) {
      const body = {
        name: "",
        login: "",
        pageSize: 20,
        pageNumber: 1,
        countryId: 0,
        active: "true",
        slug: value,
        subscriptionDate: "",
      };

      dispatch(getAffiliateAll(body)).then((affiliate) => {
        childInputChange({ id: "affiliateName", value: affiliate ? affiliate?.user?.name : "Nao encontrado!" }, index);
      });
    }
  };

  return (
    <div className="input-demoClassSchedules-array">
      <h3>{t("LINGOS")}</h3>
      {data?.map((item, index) => {
        const atualStatus =
          demoClass && demoClass[0]?.demoClassSchedules[index] && demoClass[0]?.demoClassSchedules[index]?.status
            ? demoClass[0]?.demoClassSchedules[index]?.status
            : "";
        const originalClasstime =
          demoClass &&
          demoClass[0]?.demoClassSchedules[index] &&
          demoClass[0]?.demoClassSchedules[index]?.originalScheduledDateTimeUTC
            ? userTimezoneConvert(demoClass[0]?.demoClassSchedules[index]?.originalScheduledDateTimeUTC, "UTC", user)
            : "";
        const finishedStatus =
          atualStatus === "canceled" ||
          atualStatus === "cancelled" ||
          moment(originalClasstime).add(30, "minute").isBefore(atualDate)
            ? true
            : false;

        return (
          <div key={name + index} className={`input-demoClassSchedules`}>
            <div style={{ width: "75%" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div className={`input-lingoLanguageId select-wrapper`}>
                  <FormControl className="languageInput" disabled={item?.disabledEdit || finishedStatus}>
                    <Select
                      className={`${!item?.lingoLanguageId ? "placeholder" : ""} ${
                        item?.lingoLanguageId ? "invalid" : ""
                      } `}
                      name={name}
                      displayEmpty
                      disableUnderline
                      id={"lingoLanguageId"}
                      value={item?.lingoLanguageId}
                      onChange={(e) => childInputChange({ id: "lingoLanguageId", name, value: e.target.value }, index)}
                    >
                      <MenuItem value={""}>{t("SELECT")}</MenuItem>
                      {allLingos?.map((option) => (
                        <MenuItem key={option.language.name} value={option.id}>
                          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                            <FlagIcon code={option.customLang ? option.flag.split("-")[1] : option.flag} />
                            <span className="lingoLanguageItem'">&nbsp;{decryptIfEncrypted(option.language.name)}</span>
                          </div>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                {index > 0 &&
                  moment(demoClass[0]?.demoClassSchedules[index]?.scheduledStartDateTime).isAfter(moment()) && (
                    <SCButtonAddInput name="remove" onClick={(e) => removeField(e, index)}>
                      Delete <i className="fa fa-times-circle-o" aria-hidden="true" />
                    </SCButtonAddInput>
                  )}
                {index > 0 && item.disabledEdit === null && (
                  <SCButtonAddInput name="remove" onClick={(e) => removeField(e, index)}>
                    Delete <i className="fa fa-times-circle-o" aria-hidden="true" />
                  </SCButtonAddInput>
                )}
                <div className={`input-status`}>
                  <div className="select-wrapper">
                    <select
                      name={name}
                      id="status"
                      value={item?.status}
                      disabled={atualStatus === "canceled"}
                      data-item={item?.status.toUpperCase()}
                      onChange={(e) => childInputChange(e.target, index)}
                    >
                      {statusOptions.map((option) => (
                        <option className={option?.name.toUpperCase()} key={option?.name} value={option?.name}>
                          {demoClass &&
                            demoClass[0]?.demoClassSchedules[index] &&
                            option?.name === demoClass[0]?.demoClassSchedules[index]?.status &&
                            "●"}{" "}
                          {option?.name === "cancelledOutOfLimit"
                            ? t("CANCELLED_OUT_lIMIT")
                            : t(option?.name.toUpperCase())}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {showAddLingo && (
                  <SCButtonAddInput onClick={(e) => addField(e, newItem)}>
                    {t("ADD_NEW_LINGO")} <span className="plus">+</span>
                  </SCButtonAddInput>
                )}
              </div>

              {item?.lingoLanguageId && (
                <Fragment>
                  <div className="schedule">
                    <h4>{t("SCHEDULE")}</h4>
                    <div className="lineSchedule">
                      <div className={`input-scheduledDate`}>
                        <label
                          className={!item?.disabledEdit && item?.scheduledDate ? "invalid" : ""}
                          htmlFor={`scheduledDate`}
                        >
                          {t("DATE")}
                        </label>
                        <div className={`${!item?.scheduledDate ? "placeholder" : ""} select-wrapper`}>
                          {item?.scheduledDate !== "" ? (
                            <DatePicker
                              id="date"
                              name="scheduledDate"
                              dateFormat={t("DATE_FORMAT")}
                              showMonthDropdown
                              showYearDropdown
                              selected={moment(item?.scheduledDate)}
                              calendarClassName={`${!item?.scheduledDate ? "placeholder" : ""} ${
                                item?.scheduledDate ? "invalid" : ""
                              } `}
                              disabled={
                                demoClass &&
                                demoClass.length > 0 &&
                                moment(demoClass[0]?.demoClassSchedules[index]?.scheduledStartDateTime).isBefore(
                                  moment(),
                                )
                              }
                              placeholderText={t("DATE_FORMAT")}
                              customInput={<InputDatepicker />}
                              onChange={(e) => setDate({ id: "scheduledDate", value: e }, index)}
                              todayButton={t("TODAY")}
                            />
                          ) : (
                            <DatePicker
                              id="date"
                              name="scheduledDate"
                              dateFormat={t("DATE_FORMAT")}
                              showMonthDropdown
                              showYearDropdown
                              selected={scheduledDate}
                              calendarClassName={`${!item?.scheduledDate ? "placeholder" : ""} ${
                                item?.scheduledDate ? "invalid" : ""
                              } `}
                              placeholderText={t("DATE_FORMAT")}
                              customInput={<InputDatepicker />}
                              onChange={(e) => setDate({ id: "scheduledDate", value: e }, index)}
                              todayButton={t("TODAY")}
                            />
                          )}
                        </div>
                      </div>
                      <div className={`input-scheduledStart`}>
                        <label className={item?.scheduledStart ? "invalid" : ""} htmlFor={`scheduledStart`}>
                          {t("START_TIME")}
                        </label>
                        <div className={`${!item?.scheduledStart ? "placeholder" : ""} select-wrapper`}>
                          <select
                            className={`${!item?.scheduledDate ? "placeholder" : ""} ${
                              item?.scheduledDate ? "invalid" : ""
                            } `}
                            name={name}
                            id="scheduledStart"
                            value={item?.scheduledStart}
                            onChange={(e) => childInputChange(e.target, index)}
                            disabled={item?.disabledEdit || finishedStatus}
                          >
                            <option value={""}> {t("SELECT")}</option>
                            {lingoClassTimes?.map((option) => (
                              <option key={option.start} value={option.start}>
                                {" "}
                                {moment(option.start, "HH:mm:ss").format("hh:mm A")}{" "}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className={`input-scheduledEnd`}>
                        <label htmlFor={`scheduledEnd`}>{t("END_TIME")}</label>
                        <input
                          type={"text"}
                          name={name}
                          id="scheduledEnd"
                          value={
                            item?.scheduledStart && item?.scheduledDate
                              ? moment(`${item?.scheduledDate} ${item?.scheduledStart}`)
                                  .add(30, "minutes")
                                  .format("hh:mm A")
                              : ""
                          }
                          readOnly
                        />
                      </div>
                      {item?.scheduledStart && item?.scheduledDate && (
                        <p className="studentTimezone">
                          {t("SHCEDULING_IN")}
                          <br />
                          <span>{t("STUDENTS_TIMEZONE")}</span>
                        </p>
                      )}
                    </div>
                  </div>

                  {item?.scheduledDate && item?.scheduledStart && timezone && (
                    <div className="schedule_tmz">
                      <p>
                        {moment(
                          userTimezoneConvert2(item?.scheduledDate + "T" + item?.scheduledStart + ".000", timezone),
                          "HH:mm:ss",
                        ).format(t("DATE_FORMAT"))}{" "}
                      </p>

                      <p>
                        {moment(
                          userTimezoneConvert2(item?.scheduledDate + "T" + item?.scheduledStart + ".000", timezone),
                          "HH:mm:ss",
                        ).format("hh:mm A")}{" "}
                      </p>

                      <p>
                        {moment(
                          userTimezoneConvert2(item?.scheduledDate + "T" + item?.scheduledStart + ".000", timezone),
                          "HH:mm:ss",
                        )
                          .add(30, "minutes")
                          .format("hh:mm A")}{" "}
                      </p>
                      <p>
                        {t("SHCEDULING_IN")}
                        <br />
                        <span>{t("YOUR_TIMEZONE")}</span>
                      </p>
                    </div>
                  )}

                  <h4>{t("AFFILIATE")}</h4>

                  <div className="lineSchedule">
                    <div>
                      <label>Slug</label>
                      <div className={"select-wrapper"}>
                        <input
                          id="affiliateSlug"
                          value={item?.affiliateSlug}
                          onChange={(e) => childInputChange(e.target, index)}
                          onBlur={(e) => handleAffiliateSlug(e, index, item?.affiliateId)}
                        />
                      </div>
                    </div>

                    <div>
                      <label>Affiliate Name</label>
                      <div>
                        <input
                          disabled
                          id="affiliateName"
                          className="inputNameAffiliate"
                          value={decryptIfEncrypted(item?.affiliateName)}
                        />
                      </div>
                    </div>

                    <SCButtonAddInput>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                          Number(nativeLanguageId) === 212
                            ? urlBR + `${item?.affiliateSlug}`
                            : Number(nativeLanguageId) === 232
                            ? urlES + `${item?.affiliateSlug}`
                            : Number(nativeLanguageId) === 131 //french
                            ? urlUS + `${item?.affiliateSlug}`
                            : urlUS + `${item?.affiliateSlug}`
                        }
                      >
                        Link {t("AFFILIATE")}
                      </a>
                    </SCButtonAddInput>
                  </div>

                  <div className="teacher">
                    <h4>{t("ASSIGNED_TEACHER")}</h4>
                    <div className="teacherFlex">
                      <div className="avatar">
                        <img
                          src={
                            (teacherManagement.filter((teacher) => teacher.teacherId === Number(item?.teacherId))[0] &&
                              teacherManagement.filter((teacher) => teacher.teacherId === Number(item?.teacherId))[0]
                                .picture) ||
                            IconAvatar
                          }
                          alt=""
                        />
                      </div>
                      <div>
                        <div className={`input-teacherId`}>
                          <div className={`${!item?.teacherId ? "placeholder" : ""} select-wrapper`}>
                            <select
                              name={name}
                              id="teacherId"
                              value={item?.teacherId}
                              disabled={item?.disabledEdit || finishedStatus}
                              onChange={(e) => childInputChange(e.target, index)}
                            >
                              <option value={""}> {t("SELECT")}</option>
                              {(() => {
                                const selectedLanguageName = allLingos.find(
                                  (language) => language.id === item?.lingoLanguageId,
                                )?.language?.name;

                                return (
                                  teachersAndCoordinators
                                    .filter(({ languagesOfTeacher }) => {
                                      return languagesOfTeacher.nativeLanguages.includes(selectedLanguageName);
                                    })
                                    // .filter(({ nativeLanguageName, otherLanguageName }) => {
                                    //   return nativeLanguageName === "bilingual" || otherLanguageName === "bilingual";
                                    // })
                                    .map((option, index) => (
                                      <option key={option.name + index} value={option.id}>
                                        {decryptIfEncrypted(option.name)}
                                      </option>
                                    ))
                                );
                              })()}
                            </select>
                          </div>
                        </div>
                        {item?.teacherId && (
                          <div className="teacher-rating">
                            <h4>{t("AVARAGE_RATING")}:</h4>
                            <p>
                              {teacherManagement.filter(
                                (teacher) => teacher.teacherId === Number(data[index].teacherId),
                              )[0] &&
                                teacherManagement.filter(
                                  (teacher) => teacher.teacherId === Number(data[index].teacherId),
                                )[0].averageRating}
                            </p>
                          </div>
                        )}
                        <div className="teacher-info">
                          <p>
                            {t("NATIVE_LANGUAGE")}:{" "}
                            {teacherManagement.filter(
                              (teacher) => teacher.teacherId === Number(data[index].teacherId),
                            )[0] &&
                              teacherManagement.filter(
                                (teacher) => teacher.teacherId === Number(data[index].teacherId),
                              )[0].nativeLanguageName}
                          </p>
                          <p>
                            {t("COUNTRY")}:{" "}
                            {teacherManagement.filter(
                              (teacher) => teacher.teacherId === Number(data[index].teacherId),
                            )[0] &&
                              teacherManagement.filter(
                                (teacher) => teacher.teacherId === Number(data[index].teacherId),
                              )[0].countryName}
                          </p>
                          <p>
                            {t("TELEPHONE")}:{" "}
                            {teacherManagement.filter(
                              (teacher) => teacher.teacherId === Number(data[index].teacherId),
                            )[0] &&
                              teacherManagement.filter(
                                (teacher) => teacher.teacherId === Number(data[index].teacherId),
                              )[0].userPhones &&
                              teacherManagement
                                .filter((teacher) => teacher.teacherId === Number(data[index].teacherId))[0]
                                .userPhones.split(",")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="teacherFlexSelects">
                    <div className={`input-levelByStudent`}>
                      <label className={item?.levelByStudent ? "invalid" : ""} htmlFor="levelByStudent">
                        {t("LEVEL_BY_STUDENT")}
                      </label>
                      <span>{t("REQUIRED_FIELD")}</span>
                      <div className="select-wrapper">
                        <select
                          name={name}
                          id="levelByStudent"
                          value={item?.levelByStudent}
                          disabled={item?.disabledEdit || finishedStatus}
                          className={item?.levelByStudent ? "invalid" : ""}
                          onChange={(e) => childInputChange(e.target, index)}
                        >
                          <option value={""}> {t("SELECT")}</option>
                          {levelOptions.map((option, index) => (
                            <option key={option.name + index} value={option.name}>
                              {option.name.toUpperCase()}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className={`input-levelByLingo`}>
                      <label htmlFor="levelByLingo">{t("REAL_LEVEL")}</label>
                      <div className="select-wrapper">
                        <select
                          disabled
                          name={name}
                          id="levelByLingo"
                          value={item?.levelByLingo}
                          onChange={(e) => childInputChange(e.target, index)}
                        >
                          <option value={""}> {t("SELECT")}</option>
                          {lingoLevelsOptions?.map((option, index) => (
                            <option key={option?.name + index} value={option?.name}>
                              {option?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default InputForLingoArray;
